var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"app-layout-default"},[_c('the-white-navigation'),_vm._v(" "),_c('main',[_c('nuxt')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }